import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const TimezoneInput = ({name, label, options, load, onChange=null, rules=null, placeholder=null, ...props}) => {

  // load tags on mount
  useEffect(() => {
    load();
  }, [load]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label ? label : t('user_account_form_input_timezones')}
          rules={rules}
        >
          <Select
            showSearch
            disabled={props.isLoading || props.isSubmitting}
            loading={props.isLoading}
            onChange={onChange}
            showArrow={true}
            placeholder={placeholder}
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default TimezoneInput;
